import { Injectable } from '@angular/core';
import { FuiModalService } from 'ngx-fomantic-ui';
import { ConfirmModal } from '../model/confirm.model';
import { ForceConfirmModal } from '../model/force-confirm.model';

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(private modalService: FuiModalService) {}

  public confirmModal(title, message, modalSize?): any {
    return this.modalService.open(new ConfirmModal(title, message, modalSize));
  }

  public forceConfirmModal(title, message, modalSize?): any {
    return this.modalService.open(
      new ForceConfirmModal(title, message, modalSize)
    );
  }
}
